import BodyLayout from './BodyLayout'

export default BodyLayout
